import React, { FC } from 'react';
import { BaseButtonContainer } from './baseButton.sc';

export interface BaseButtonProps {
  onClick?: (event) => void;
  className?: string;
  children: any;
  buttonStyle: 'contained' | 'outlined';
  disabled?: boolean;
  ariaLabel?: string;
  ariaExpanded?: 'true' | 'false';
  'data-test-automation-id'?: string;
}

export const BaseButton: FC<BaseButtonProps> = ({
  onClick,
  className = '',
  children,
  buttonStyle,
  disabled = false,
  ariaLabel,
  ariaExpanded,
  'data-test-automation-id': dataTestAutomationId = 'base-button',
}) => {
  return (
    <BaseButtonContainer
      variant={buttonStyle}
      color="text.primary"
      onClick={onClick}
      className={`${className}`}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      data-test-automation-id={dataTestAutomationId}
    >
      {children}
    </BaseButtonContainer>
  );
};
